import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const ArchivoUploadModal = ({
  open,
  onClose,
  archivo,
  setArchivo,
  nombre,
  setNombre,
  subiendo,
  onSubir
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-[#0E3A53]">
            Subir Archivo Adicional
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="nombre-archivo" className="text-[#0E3A53]">
              Nombre del archivo (opcional)
            </Label>
            <Input
              id="nombre-archivo"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ej: Cédula de identidad, Comprobante de pago..."
              className="mt-1"
            />
          </div>
          
          <div>
            <Label htmlFor="archivo-adicional" className="text-[#0E3A53]">
              Seleccionar archivo
            </Label>
            <p className="text-sm text-gray-500 mb-2">PDF, imágenes o documentos (máx. 5 archivos por reserva)</p>
            <Input
              id="archivo-adicional"
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              onChange={(e) => setArchivo(e.target.files[0])}
              className="cursor-pointer mt-1"
            />
            {archivo && (
              <p className="text-sm text-green-600 mt-2">
                ✓ Archivo seleccionado: {archivo.name}
              </p>
            )}
          </div>

          <div className="flex gap-2 justify-end pt-4">
            <Button 
              variant="outline" 
              onClick={onClose}
              disabled={subiendo}
            >
              Cancelar
            </Button>
            <Button 
              onClick={onSubir}
              disabled={!archivo || subiendo}
              className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]"
            >
              {subiendo ? 'Subiendo...' : 'Subir Archivo'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ArchivoUploadModal;
